import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  stepOneSharedData: any;
  stepTwoSharedData: any;
  stepFourSharedData: any;
  stepFiveSharedData: any;

  stepThreeSharedDataPurchases: any;
  stepThreeSharedDataDistributions: any;
  stepThreeSharedDataSales: any;
  stepThreeSharedDataClosing: any;

  completedStatusData: any;

  private dataSubject = new Subject<boolean>();

  sendData(data: boolean) {
    this.dataSubject.next(data);
  }

  getData() {
    return this.dataSubject.asObservable();
  }
  constructor() { }
}
